// extracted by mini-css-extract-plugin
export default {"checkIcon":"ApplyStepsIntro_checkIcon__PB0gC","subtitle":"ApplyStepsIntro_subtitle__n8fKg","skeletonLoadingAnimation":"ApplyStepsIntro_skeletonLoadingAnimation__UDe9N"};